<template>
    <div class="main-status-setting">
        <CreateNewCallModal :create_new.sync="modals.create_new"  v-on:getnewstatus="getStatus()" @closeModal="closeModal" @tutupModal="tutupModal()" />
        <CallLogForm :log_call.sync="modals.log_call" @closeModal="closeModal" />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Profile</p>
                    <h2 class="listing-title d-inline-block mb-0">Calls</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="modals.log_call = true" hidden>Log Call</b-button>
                    <!-- <b-button variant="primary" class="btn-header" @click="openModal">Call</b-button> -->
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CallTable></CallTable>
        </b-container>
    </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import UpdateStatusModal from '@/views/Configurations/MainStatusSettings/MainStatusModals/UpdateStatusModal'
import CallTable from '@/views/Call/CallTable'
import CreateNewCallModal from '@/views/Call/Modal/CreateNewCallModal'
import CallFilterDrawer from '@/views/Call/Drawer/CallFilter'
import CallLogForm from '@/views/Call/Modal/LogNewCallModal'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'



export default {
    components: {
        CallTable,
        CallFilterDrawer,
        RouteBreadCrumb,
        CreateNewCallModal,
        UpdateStatusModal,
        CallLogForm,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            modals:{
                create_new: false,
                update_status: false,
                log_call: false
            },
            backButton: false,
        };
    },
    created() {
        if(this.$route.params.token)
        {
            this.backButton = true;
        }
    },
    
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        },
        openModal() {
            this.modals.create_new = true;
        },
        closeModal(){
            this.modals.log_call = false;
        },
        filterByStatus(data){
            if(!data.length == 0){
                let filteredData = []
                this.isTableLoading = true
                this.tableData = []
                this.allCallsData[0].forEach(element => {
                    data.forEach(status => {
                        element.status.current.main === status ? filteredData.push(element) : ""
                    });
                });
                this.isTableLoading = false
                this.tableData = filteredData
            }else{
                this.tableData = this.allLeadsData[0]
            }

        },
    }
}
</script>